import imageVaralIndividualParede from "./../static/varais-500px/varal-individual-parede.png";
import imageVaralMuro from "./../static/varais-500px/varal-muro.png";
import imageVaralSanfonado from "./../static/varais-500px/varal-sanfonado.png";
import imageVaralTradicionalParede from "./../static/varais-500px/varal-tradicional-parede.png";
import imageVaralTradicional from "./../static/varais-500px/varal-tradicional.png";
import imageManivelaVaral from "./../static/varais-500px/manivela-varal.png";
import imageVaralTradicionalTetoManivela from "./../static/varais-500px/varal-tradicional-teto-manivela.jpg";
import imageVaralTradicionalParedeManivela from "./../static/varais-500px/varal-tradicional-parede-manivela.jpg";
import imageVaralMuroRemovivel from "./../static/varais-500px/varal-muro-removivel.jpg";
import imageVaralMagico from "./../static/varais-500px/varal-magico.jpg";
import imageOlhoMagico from "./../static/varais-500px/olho-magico.jpg";
import imagePrendedores from "./../static/prendedores/prendedores.png";

export default [
  {
    title: "Varal Individual de Parede",
    imageDefault: imageVaralIndividualParede,
    description: ""
  },
  {
    title: "Varal de Muro",
    imageDefault: imageVaralMuro,
    description: ""
  },
  {
    title: "Varal Sanfonado",
    imageDefault: imageVaralSanfonado,
    description: ""
  },
  {
    title: "Varal Tradicional de Parede",
    imageDefault: imageVaralTradicionalParede,
    description: ""
  },
  {
    title: "Varal Tradicional",
    imageDefault: imageVaralTradicional,
    description: ""
  },
  {
    title: "Manivela Redutora de Peso",
    imageDefault: imageManivelaVaral,
    description: "Manivela para varais tradicionais."
  },
  {
    title: "Varal de Teto com Manivela",
    imageDefault: imageVaralTradicionalTetoManivela,
    description: "Varal de Teto com manivela para controle."
  },
  {
    title: "Varal de Parede com Manivela",
    imageDefault: imageVaralTradicionalParedeManivela,
    description: "Varal de tradicional de parede com manivela para controle."
  },
  {
    title: "Varal de Muro Removível",
    imageDefault: imageVaralMuroRemovivel,
    description: "Varal de muro que pode ser removido."
  },
  {
    title: "Varal Mágico",
    imageDefault: imageVaralMagico,
    description:
      "Varal de mágico, que pode ser aberto para uso a qualquer momento e recolhido após o uso."
  },
  {
    title: "Prendedores",
    imageDefault: imagePrendedores,
    description: "Prendedores."
  },
  {
    title: "Olho Mágico",
    imageDefault: imageOlhoMagico,
    description: "Oho Mágico."
  }
];
